import { useCallback } from 'react'
import PropTypes from 'prop-types'

export default function FilePicker({ multiple, value, onChange, accept }) {
  const inputRef = useCallback(
    node => {
      if (node) {
        node.click()
      }
    },
    // This dep ensures the file dialog is opened when the value is cleared,
    // although it's an unecessary dep in eslint's opinion. We should
    // probably do this in some better way.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  )

  return (
    <input
      type="file"
      multiple={multiple}
      accept={accept}
      id="individual-files-input"
      ref={inputRef}
      style={{ display: 'none' }}
      onChange={e => {
        const files = {}
        Array.from(e.target.files).forEach(file => {
          files[file.name] = {
            file,
            isSelected: false,
            uploadStatus: 'idle',
            id: file.name,
          }
        })
        onChange(files)
      }}
    />
  )
}

FilePicker.propTypes = {
  multiple: PropTypes.bool,
  value: PropTypes.array,
  onChange: PropTypes.func,
  accept: PropTypes.string,
}
